import { render, staticRenderFns } from "./PainPointsSection.vue?vue&type=template&id=05d6b594&scoped=true"
import script from "./PainPointsSection.vue?vue&type=script&lang=js"
export * from "./PainPointsSection.vue?vue&type=script&lang=js"
import style0 from "./PainPointsSection.vue?vue&type=style&index=0&id=05d6b594&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "05d6b594",
  null
  
)

export default component.exports